import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('maslow-pyramids', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: 'url(#' + props.id + '6211b18f' + ')'
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 4L15 19.9803H33L24 4Z",
    fill: props.colors[1],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 19.9805L24.0083 44.0001",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3466 25.9746L2 42.0001H17.0046",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10059 30.9951H17.0049",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7481 25.9746L46.0947 42.0001H31.0004",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0947 30.9951H31.1007",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: props.id + '6211b18f'
  }, /*#__PURE__*/React.createElement("rect", {
    width: "48",
    height: "48",
    fill: props.colors[2]
  }))));
});